import React from 'react';
import PropTypes from 'prop-types';
import EvaluationSentCompactDialogView from '@fingo/lib/features/factoring/views/EvaluationSentCompactDialogView';

const EvaluationSentDialog = ({
  open,
  onClose,
  warningMessage,
}) => (
  <EvaluationSentCompactDialogView
    open={open}
    onClose={onClose}
    title="Enviaste tus facturas a evaluación"
    description="Te avisaremos cuando la evaluación esté disponible."
    acceptButtonLabel="Entendido"
    hideCloseButton={false}
    warningMessage={warningMessage}
  />
);

EvaluationSentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  warningMessage: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }),
};

EvaluationSentDialog.defaultProps = {
  warningMessage: null,
};

export default EvaluationSentDialog;
